import ResizableModal from '../../../../../ui/ResizableModal'
import QuestionIcon from '@mui/icons-material/HelpOutline'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles'

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#000033',
    color: '#fff',
    fontSize: '0.75rem',
    padding: '6px 12px',
    borderRadius: '6px',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#000033',
  },
}));

const Tarjetas = ({ open, setOpen, items = [], title, onCardClick }) => {
    const handleClose = () => {
        setOpen(false)
    }

  return (
     <ResizableModal open={open} onClose={handleClose}>
    <div className="p-4">
        {items.length > 0 ? (
          <div className="flex flex-wrap gap-4 justify-center">
            {items.map((item) => (
              <div
                key={item.id}
                className="relative flex flex-col items-center justify-center shadow-md border rounded-xl 
                          p-2 cursor-pointer w-24 h-24 md:w-21 md:h-21"
                onClick={() => {
                  setOpen(false)      // Cierra el modal
                  onCardClick(item.id) // Abre el modal real
                }}
              >
                {/* Mostrar tooltip solo si NO es 13a o 13b */}
                {item.id !== '13a' && item.id !== '13b' && item.id !== '13c' && (
                  <div
                    className="absolute top-0 right-1"
                    onClick={(e) => e.stopPropagation()} // evita que cierre modal al hacer clic
                  >
                    <CustomTooltip title={item.tooltipText || "Sin descripción"} arrow>
                      <QuestionIcon
                        fontSize="inherit"
                        className="text-gray-400 hover:text-gray-500 cursor-pointer"
                        style={{ fontSize: '16px' }} // más pequeño
                      />
                    </CustomTooltip>
                  </div>
                )}

                <item.icon className="w-14 h-14 md:w-12 md:h-12 mb-1" />
                <h3 className="text-[9px] font-semibold text-center leading-tight">
                  {item.title}
                </h3>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-sm text-gray-500 mt-4">
            No existen más vinculaciones
          </p>
        )}
      </div>
    </ResizableModal>
  )
}

export default Tarjetas
